import { mapActions, mapState } from 'vuex'
import AuditLogButton from '@/components/sys/audit/AuditLogButton.vue'
import {
    SERIE, SEM_CURSO, SEM_REGIME, SEM_TITULACAO,
    REGIMES_BASE, REGIMES, TITULACOES,
    PARAM_PADRAO,
} from './indicatorsMockData'

// Agrupam as linhas dos endpoints de resumo em mapas por categoria (usados no período atual e no anterior).
function contarRegimes(linhas) {
    const map = { 1: 0, 2: 0, 3: 0, null: 0 }
    linhas.forEach(r => {
        const key = r.teacher_work_regime_id === null ? null : Number(r.teacher_work_regime_id)
        map[key] = Number(r.total)
    })
    return map
}

function contarTitulacoes(linhas) {
    const map = { especialista: 0, mestre: 0, doutor: 0, semTitulacao: 0 }
    linhas.forEach(r => {
        const id = r.teacher_titling_id === null ? null : Number(r.teacher_titling_id)
        const total = Number(r.total)
        if (id === 3) map.especialista += total
        else if (id === 4) map.mestre += total
        else if (id === 5 || id === 6) map.doutor += total
        else map.semTitulacao += total
    })
    return map
}

// Variação em relação ao período anterior; null quando não há base de comparação
// (período anterior sem indicadores gerados).
function variacao(atual, anterior, baseAnterior, casas = 0) {
    if (!baseAnterior) return null
    const v = atual - anterior
    return casas ? Number(v.toFixed(casas)) : v
}

export default {
    name: 'SysTeacherIndicatorsModal',

    components: { AuditLogButton },

    props: {
        show: { type: Boolean, default: false },
    },

    data: () => ({
        dialog: false,

        cursosSelecionados: [], professoresSelecionados: [], empresasSelecionadas: [],
        // Filtros de Empresa/Curso/Professor em vigor nos indicadores: as listas acima são só a
        // seleção nos campos e passam para estas ao clicar em "Aplicar filtros".
        cursosAplicados: [], professoresAplicados: [], empresasAplicadas: [],
        regimeCat: '', tituloCat: '', busca: '',
        sortKey: 'nome', sortDir: 1, page: 0,
        regimeAberto: false, titulacaoAberta: false,
        paramAberto: false,
        paramsState: null,
        rascunhoState: null,
        cursoBusca: '', cursoOrdem: 'maior', cursoPagina: 0, cursosTodos: false,
        porPagina: 8,

        // Tabela Docentes Ativos (teacher_indicators/active-teachers), paginada no backend.
        docentesReal: [],
        docentesMeta: { page: 1, total: 0, last_page: 1 },
        docentesCarregando: false,
        // Requisições de indicadores em andamento (para o indicador de carregamento).
        pendentes: 0,
        baixandoCsv: false,

        // Docentes por curso x regime x titulação (teacher_indicators/summary-by-course) —
        // alimenta os gráficos de barras por curso e o ranking de mestres e doutores.
        courseSummaryReal: [],

        // CH total e docentes por regime (teacher_indicators/summary-ch-by-regime).
        chRegimeReal: [],
        courseSummaryCarregado: false,

        institutionTypeRuleAtual: null,
        institutionTypeRuleCarregado: false,

        // Lista de tipos de instituição (institution_types) e suas regras (institution_type_rules),
        // usadas para montar o seletor "Perfil" das Parametrizações de forma dinâmica —
        // mesmas rotas já utilizadas na tela "Regras por Tipo de Instituição".
        institutionTypesReal: [],
        institutionTypesCarregado: false,
        institutionTypeRulesReal: [],
        institutionTypeRulesCarregado: false,

        // Regras reais de CH mínima/% extraclasse por regime de trabalho
        // (teacher_work_regime_rules — mesma fonte da tela Regras de Regime de
        // Trabalho), usadas no quadrante "Carga horária por regime".
        teacherWorkRegimeRulesReal: [],
        teacherWorkRegimeRulesCarregado: false,

        // Feedback da gravação em institution_type_rules/teacher_work_regime_rules
        // ao clicar em Aplicar.
        salvandoParam: false,
        paramMensagem: '',
        paramErro: false,

        // Contagem real de docentes ativos por regime de trabalho (teacher_indicators),
        // no período letivo atual — ainda sem filtro por curso/professor.
        regimeSummaryReal: [],
        regimeSummaryCarregado: false,
        // Mesmos indicadores no período letivo anterior (previous=1), para as variações dos cards.
        regimeSummaryAnterior: [],
        titlingDetailAnterior: [],
        activeTeachersAnterior: { total: 0 },
        chRegimeAnterior: [],

        // Total de docentes indicados no período atual e quantos são mestres/doutores
        // (teacher_indicators + teachers.teacher_titling_id in (4,5,6)).
        titlingSummaryReal: { total: 0, mestres_doutores: 0 },
        titlingSummaryCarregado: false,

        // Contagem real de docentes ativos por titulação (teachers.teacher_titling_id),
        // no período letivo atual — para os cards e a pizza do painel Titulação.
        titlingDetailReal: [],
        titlingDetailCarregado: false,

        // Docentes Ativos: teacher_indicators + teachers.active=1 e teacher_status_id=1.
        activeTeachersSummaryReal: { total: 0 },
        activeTeachersSummaryCarregado: false,

    }),

    watch: {
        dialog(novo, antigo) {
            if (novo !== antigo) this.$emit('update:show', novo)
            if (novo && !this.institutionTypeRuleCarregado) {
                this.institutionTypeRuleCarregado = true
                this.carregarInstitutionTypeRuleAtual()
            }
            if (novo && !this.institutionTypesCarregado) {
                this.institutionTypesCarregado = true
                this.carregarInstitutionTypesReal()
            }
            if (novo && !this.institutionTypeRulesCarregado) {
                this.institutionTypeRulesCarregado = true
                this.carregarInstitutionTypeRulesReal()
            }
            if (novo && !this.teacherWorkRegimeRulesCarregado) {
                this.teacherWorkRegimeRulesCarregado = true
                this.carregarTeacherWorkRegimeRulesReal()
            }
            if (novo && !this.regimeSummaryCarregado) {
                this.regimeSummaryCarregado = true
                this.carregarRegimeSummaryReal()
            }
            if (novo && !this.titlingSummaryCarregado) {
                this.titlingSummaryCarregado = true
                this.carregarTitlingSummaryReal()
            }
            if (novo && !this.titlingDetailCarregado) {
                this.titlingDetailCarregado = true
                this.carregarTitlingDetailReal()
            }
            if (novo && !this.activeTeachersSummaryCarregado) {
                this.activeTeachersSummaryCarregado = true
                this.carregarActiveTeachersSummaryReal()
            }
            if (novo) this.carregarDocentes()
            if (novo) this.carregarChRegime()
            if (novo && !this.courseSummaryCarregado) {
                this.courseSummaryCarregado = true
                this.carregarCourseSummary()
            }
        },
        show(novo) {
            this.dialog = novo
        },
        // Mudou o recorte aplicado (empresa/curso/professor): volta para a primeira página.
        cursosAplicados() { this.page = 0 },
        professoresAplicados() {
            this.page = 0
            if (this.dialog) this.carregarCourseSummary()
        },
        empresasAplicadas() {
            this.page = 0
            if (this.dialog) this.carregarCourseSummary()
        },
        // Cada indicador recarrega quando muda o recorte que o afeta (filtros + base de
        // cálculo). As chaves são JSON para não disparar à toa quando só a identidade muda.
        docentesQueryKey() {
            if (this.dialog) this.agendarDocentes()
        },
        filtrosBaseKey() {
            if (!this.dialog) return
            this.carregarRegimeSummaryReal()
            this.carregarChRegime()
        },
        filtrosTitulacaoKey() {
            if (!this.dialog) return
            this.carregarTitlingSummaryReal()
            this.carregarTitlingDetailReal()
        },
        filtrosTodosKey() {
            if (this.dialog) this.carregarActiveTeachersSummaryReal()
        },
        baseCalculoKey() {
            if (this.dialog) this.carregarCourseSummary()
        },
    },

    computed: {
        ...mapState('auth', ['user', 'acesso']),
        isInternal() { return !!(this.user && this.user.is_internal) },

        // Metas padrão (antes de qualquer ajuste manual nas Parametrizações):
        // % mínimo de tempo integral e de mestres/doutores vindos da regra real
        // cadastrada em institution_type_rules para o tipo da instituição logada.
        // Ausência de regra/institution_type_id ou piso não definido (null) => 0,
        // que o restante do dashboard já trata como "Sem meta".
        metasPadraoInstituicao() {
            const regra = this.institutionTypeRuleAtual
            return {
                metaTI: regra && regra.min_fulltime != null ? Number(regra.min_fulltime) : 0,
                metaStricto: regra && regra.min_master_doctors != null ? Number(regra.min_master_doctors) : 0,
            }
        },
        // Perfil (institution_type_id) da própria instituição logada, usado como valor
        // inicial do seletor "Perfil" nas Parametrizações — cai para o primeiro tipo
        // cadastrado quando a instituição não tem institution_type_id definido.
        perfilPadrao() {
            if (this.institutionTypeRuleAtual) return String(this.institutionTypeRuleAtual.institution_type_id)
            return this.institutionTypesReal.length ? String(this.institutionTypesReal[0].id) : ''
        },
        // CH mínima/% extraclasse padrão (antes de qualquer ajuste manual), a partir
        // das regras reais de teacher_work_regime_rules da instituição logada —
        // Horista (id 1), Tempo Parcial (id 2) e Tempo Integral (id 3). Cai no
        // PARAM_PADRAO quando a regra ainda não carregou ou não existe para o regime.
        chPadraoInstituicao() {
            const hr = this.teacherWorkRegimeRulesReal.find(r => r.teacher_work_regime_id === 1)
            const tp = this.teacherWorkRegimeRulesReal.find(r => r.teacher_work_regime_id === 2)
            const ti = this.teacherWorkRegimeRulesReal.find(r => r.teacher_work_regime_id === 3)
            return {
                hrMin: hr ? Number(hr.work_load_min) : PARAM_PADRAO.hrMin,
                hrExtra: hr ? Number(hr.percent_activities) : PARAM_PADRAO.hrExtra,
                tpMin: tp ? Number(tp.work_load_min) : PARAM_PADRAO.tpMin,
                tpExtra: tp ? Number(tp.percent_activities) : PARAM_PADRAO.tpExtra,
                tiMin: ti ? Number(ti.work_load_min) : PARAM_PADRAO.tiMin,
                tiExtra: ti ? Number(ti.percent_activities) : PARAM_PADRAO.tiExtra,
            }
        },
        params() {
            if (this.paramsState) return this.paramsState
            return { ...PARAM_PADRAO, ...this.metasPadraoInstituicao, ...this.chPadraoInstituicao, perfil: this.perfilPadrao }
        },
        rascunho() {
            return this.rascunhoState || this.params
        },

        // Base de cálculo vigente (Parametrizações aplicadas), enviada a todos os indicadores:
        // curso do docente, classificação do regime e se licenciados entram na base.
        baseCalculo() {
            return {
                course_basis: this.params.cursoRef,
                regime_basis: this.params.regimeRef,
                include_on_leave: this.params.licenciados ? 1 : 0,
            }
        },
        baseCalculoKey() { return JSON.stringify(this.baseCalculo) },

        // Titulação — dados reais (teacher_indicators + teachers.teacher_titling_id).
        totalTitlingReal() { return this.titlingSummaryReal.total },
        strictoCountReal() { return this.titlingSummaryReal.mestres_doutores },
        pctStrictoReal() { return this.totalTitlingReal ? (this.strictoCountReal / this.totalTitlingReal) * 100 : 0 },

        // Contagem real por categoria de titulação, a partir de teachers.teacher_titling_id
        // (1 Sem Formação, 2 Nível superior sem pós, 3 Especialização, 4 Mestrado,
        // 5 Doutorado, 6 Pós-Doutorado, ou null): agrupa 1/2/null em "Sem Titulação"
        // e 5/6 em "Doutores", para os 4 cards e a pizza do painel Titulação.
        titlingCountsMap() { return contarTitulacoes(this.titlingDetailReal) },
        titlingCountsMapAnterior() { return contarTitulacoes(this.titlingDetailAnterior) },
        titlingDetailTotalAnterior() {
            const m = this.titlingCountsMapAnterior
            return m.especialista + m.mestre + m.doutor + m.semTitulacao
        },
        titlingDetailTotalReal() {
            const m = this.titlingCountsMap
            return m.especialista + m.mestre + m.doutor + m.semTitulacao
        },

        // Regime de Trabalho — dados reais (teacher_indicators).
        // Chave null = docentes ativos sem indicador de regime calculado ainda ("Sem Regime").
        regimeCountsMap() { return contarRegimes(this.regimeSummaryReal) },
        regimeCountsMapAnterior() { return contarRegimes(this.regimeSummaryAnterior) },
        regimeTotalAnterior() {
            const m = this.regimeCountsMapAnterior
            return m[1] + m[2] + m[3] + m[null]
        },
        regimeTotalReal() {
            const m = this.regimeCountsMap
            return m[1] + m[2] + m[3] + m[null]
        },
        integralCountReal() { return this.regimeCountsMap[3] },
        pctTIReal() { return this.regimeTotalReal ? (this.integralCountReal / this.regimeTotalReal) * 100 : 0 },

        // Gráfico de pizza "% Professores por Regime de Trabalho" com dados reais.
        regimePieReal() {
            const ids = [1, 2, 3, null]
            const totais = ids.map(id => this.regimeCountsMap[id])
            const soma = totais.reduce((a, b) => a + b, 0) || 1
            let ang = -Math.PI / 2
            const fatias = []
            const rotulos = []
            REGIMES.forEach((c, i) => {
                const frac = totais[i] / soma
                if (frac <= 0) return
                const a1 = ang + frac * Math.PI * 2
                fatias.push({ d: this.fatia(100, 100, 88, ang, a1), fill: SERIE[i], opacidade: this.regimeCat && this.regimeCat !== c ? 0.3 : 1, onClick: () => this.setRegimeCat(c) })
                if (frac > 0.05) {
                    const mid = (ang + a1) / 2
                    rotulos.push({ x: (100 + 58 * Math.cos(mid)).toFixed(1), y: (100 + 58 * Math.sin(mid)).toFixed(1), fill: i === 1 ? '#023D5B' : '#FFFFFF', texto: (frac * 100).toFixed(1) + '%' })
                }
                ang = a1
            })
            return {
                fatias, rotulos,
                legenda: REGIMES.map((c, i) => ({
                    label: c, ponto: SERIE[i],
                    cor: this.regimeCat === c ? 'var(--blue-700)' : 'var(--text-body)',
                    fundo: this.regimeCat === c ? 'var(--info-soft)' : 'transparent',
                    opacidade: this.regimeCat && this.regimeCat !== c ? 0.45 : 1,
                    onClick: () => this.setRegimeCat(c),
                })),
            }
        },

        // Gráfico de pizza "% Professores por Titulação" com dados reais — mesmo
        // padrão de regimePieReal.
        titulacaoPieReal() {
            const m = this.titlingCountsMap
            const totais = [m.especialista, m.mestre, m.doutor, m.semTitulacao]
            const soma = totais.reduce((a, b) => a + b, 0) || 1
            let ang = -Math.PI / 2
            const fatias = []
            const rotulos = []
            TITULACOES.forEach((c, i) => {
                const frac = totais[i] / soma
                if (frac <= 0) return
                const a1 = ang + frac * Math.PI * 2
                fatias.push({ d: this.fatia(100, 100, 88, ang, a1), fill: SERIE[i], opacidade: this.tituloCat && this.tituloCat !== c ? 0.3 : 1, onClick: () => this.setTituloCat(c) })
                if (frac > 0.05) {
                    const mid = (ang + a1) / 2
                    rotulos.push({ x: (100 + 58 * Math.cos(mid)).toFixed(1), y: (100 + 58 * Math.sin(mid)).toFixed(1), fill: i === 1 ? '#023D5B' : '#FFFFFF', texto: (frac * 100).toFixed(1) + '%' })
                }
                ang = a1
            })
            return {
                fatias, rotulos,
                legenda: TITULACOES.map((c, i) => ({
                    label: c, ponto: SERIE[i],
                    cor: this.tituloCat === c ? 'var(--blue-700)' : 'var(--text-body)',
                    fundo: this.tituloCat === c ? 'var(--info-soft)' : 'transparent',
                    opacidade: this.tituloCat && this.tituloCat !== c ? 0.45 : 1,
                    onClick: () => this.setTituloCat(c),
                })),
            }
        },

        // Docentes com licença vigente hoje (limitada ao período letivo) — saem da base, salvo "Considerar licenciados".
        licenciadosNaBase() { return this.activeTeachersSummaryReal.on_leave || 0 },

        conformidade() {
            const linha = (titulo, subtitulo, atual, meta, base, contagem, iconeOk, iconeFalta) => {
                if (!meta || meta <= 0) {
                    return {
                        titulo, subtitulo, status: 'Sem meta', cor: 'var(--text-muted)', fundo: 'var(--gray-150)', icone: 'remove',
                        valor: atual.toFixed(1).replace('.', ',') + '%', alvo: 'sem meta definida',
                        largura: Math.min(100, atual) + '%', nota: contagem.toLocaleString('pt-BR') + ' docentes',
                    }
                }
                const ok = atual >= meta
                return {
                    titulo, subtitulo, status: ok ? 'Regular' : 'Irregular',
                    cor: ok ? 'var(--success)' : 'var(--danger)',
                    fundo: ok ? 'var(--success-soft)' : 'var(--danger-soft)',
                    icone: ok ? iconeOk : iconeFalta,
                    valor: atual.toFixed(1).replace('.', ',') + '%',
                    alvo: 'meta ' + meta.toFixed(1).replace('.', ',') + '%',
                    largura: Math.min(100, meta ? (atual / meta) * 100 : 0) + '%',
                    nota: ok
                        ? contagem.toLocaleString('pt-BR') + ' docentes (+' + (atual - meta).toFixed(1).replace('.', ',') + ' p.p.)'
                        : contagem.toLocaleString('pt-BR') + ' docentes (−' + (meta - atual).toFixed(1).replace('.', ',') + ' p.p.)',
                }
            }
            const regime = linha('Regime de Trabalho', 'Tempo integral', this.pctTIReal, this.params.metaTI, this.regimeTotalReal, this.integralCountReal, 'verified', 'error')
            const titulacao = linha('Titulação', 'Mestres e doutores', this.pctStrictoReal, this.params.metaStricto, this.totalTitlingReal, this.strictoCountReal, 'verified', 'error')
            return [regime, titulacao]
        },

        confRegime() { return this.confSimples(this.pctTIReal, this.params.metaTI) },
        confTitulacao() { return this.confSimples(this.pctStrictoReal, this.params.metaStricto) },

        kpiAtivos() {
            return {
                value: this.activeTeachersSummaryReal.total.toLocaleString('pt-BR'),
                delta: variacao(this.activeTeachersSummaryReal.total, this.activeTeachersAnterior.total, this.activeTeachersAnterior.total),
                tooltip: 'Docentes ativos com carga horária no período atual' + this.textoVariacao(variacao(this.activeTeachersSummaryReal.total, this.activeTeachersAnterior.total, this.activeTeachersAnterior.total)),
            }
        },
        // CH média por docente (sala + atividades) no recorte atual, a partir de chRegimeReal;
        // com filtro de regime ativo, considera só o regime filtrado.
        kpiChMedia() {
            const regimeIds = { 'Horista': 1, 'Tempo Parcial': 2, 'Tempo Integral': 3, [SEM_REGIME]: null }
            const media = linhas => {
                const rows = this.regimeCat ? linhas.filter(r => r.teacher_work_regime_id === regimeIds[this.regimeCat]) : linhas
                const n = rows.reduce((a, r) => a + Number(r.teachers), 0)
                const ch = rows.reduce((a, r) => a + Number(r.ch_total), 0)
                return { n, media: n ? ch / n : 0 }
            }
            const atual = media(this.chRegimeReal)
            const anterior = media(this.chRegimeAnterior)
            const delta = variacao(atual.media, anterior.media, anterior.n, 1)
            return {
                value: atual.n ? atual.media.toFixed(1) : '—',
                delta,
                tooltip: 'CH semanal média por docente (sala de aula + atividades) no recorte atual' + this.textoVariacao(delta),
            }
        },
        kpiIntegralParcial() {
            return {
                value: this.integralCountReal.toLocaleString('pt-BR'),
                pct: this.pct(this.integralCountReal, this.regimeTotalReal),
                tooltip: this.pct(this.integralCountReal, this.regimeTotalReal) + ' dos ativos em tempo integral',
                meta: this.metaChip(this.pctTIReal, this.params.metaTI),
            }
        },
        kpiStricto() {
            return {
                value: this.strictoCountReal.toLocaleString('pt-BR'),
                pct: this.pct(this.strictoCountReal, this.totalTitlingReal),
                tooltip: this.pct(this.strictoCountReal, this.totalTitlingReal) + ' dos ativos com stricto sensu',
                meta: this.metaChip(this.pctStrictoReal, this.params.metaStricto),
            }
        },

        kpisRegime() {
            const ids = [1, 2, 3, null]
            return REGIMES.map((r, i) => {
                const n = this.regimeCountsMap[ids[i]]
                return {
                    icon: ['schedule', 'timelapse', 'work_history', 'help'][i],
                    tone: [500, 100, 900, 700][i],
                    label: ['Horistas', 'Tempo Parcial', 'Tempo Integral', 'Sem Regime'][i],
                    value: n.toLocaleString('pt-BR'),
                    pct: this.pct(n, this.regimeTotalReal),
                    delta: variacao(n, this.regimeCountsMapAnterior[ids[i]], this.regimeTotalAnterior),
                    tooltip: r + ' · ' + this.pct(n, this.regimeTotalReal) + ' dos ativos' + this.textoVariacao(variacao(n, this.regimeCountsMapAnterior[ids[i]], this.regimeTotalAnterior)),
                    meta: r === 'Tempo Integral' ? this.metaChip(this.regimeTotalReal ? (n / this.regimeTotalReal) * 100 : 0, this.params.metaTI) : null,
                    opacidade: this.regimeCat && this.regimeCat !== r ? 0.45 : 1,
                    anel: this.regimeCat === r ? '0 0 0 2px var(--brand-blue)' : 'none',
                    dica: this.regimeCat === r ? 'Remover filtro de regime' : 'Filtrar indicadores por ' + r,
                    cat: r,
                }
            })
        },
        kpisTitulacao() {
            const ids = ['especialista', 'mestre', 'doutor', 'semTitulacao']
            return TITULACOES.map((t, i) => {
                const n = this.titlingCountsMap[ids[i]]
                return {
                    icon: ['school', 'menu_book', 'workspace_premium', 'help'][i],
                    tone: [500, 100, 900, 700][i],
                    label: ['Especialistas', 'Mestres', 'Doutores', 'Sem Titulação'][i],
                    value: n.toLocaleString('pt-BR'),
                    pct: this.pct(n, this.titlingDetailTotalReal),
                    delta: variacao(n, this.titlingCountsMapAnterior[ids[i]], this.titlingDetailTotalAnterior),
                    tooltip: t + ' · ' + this.pct(n, this.titlingDetailTotalReal) + ' dos ativos' + this.textoVariacao(variacao(n, this.titlingCountsMapAnterior[ids[i]], this.titlingDetailTotalAnterior)),
                    opacidade: this.tituloCat && this.tituloCat !== t ? 0.45 : 1,
                    anel: this.tituloCat === t ? '0 0 0 2px var(--brand-blue)' : 'none',
                    dica: this.tituloCat === t ? 'Remover filtro de titulação' : 'Filtrar indicadores por ' + t,
                    cat: t,
                }
            })
        },

        chMedia() {
            const medias = [1, 2, 3].map(id => { const g = this.chRegimeMap[id]; return g.n ? g.ch / g.n : 0 })
            const maior = Math.max(1, ...medias)
            return REGIMES_BASE.map((r, i) => ({
                label: r,
                valor: medias[i] ? medias[i].toFixed(1) + ' h' : '—',
                largura: Math.round((medias[i] / maior) * 100) + '%',
                cor: SERIE[i],
                opacidade: this.regimeCat && this.regimeCat !== r ? 0.4 : 1,
            }))
        },
        chTotal() {
            const m = this.chRegimeMap
            return (m[1].ch + m[2].ch + m[3].ch + m.null.ch).toLocaleString('pt-BR', { maximumFractionDigits: 1 })
        },

        // Docentes por curso (dados reais): cada linha do backend vira uma célula numa
        // matriz [regime][titulação] por curso, com os índices de REGIMES e TITULACOES —
        // assim qualquer combinação de filtro de regime/titulação é só uma soma.
        cursoStats() {
            const regimeIdx = id => (id === 1 ? 0 : id === 2 ? 1 : id === 3 ? 2 : 3)
            const titulacaoIdx = id => (id === 3 ? 0 : id === 4 ? 1 : (id === 5 || id === 6) ? 2 : 3)
            const mapa = {}
            this.courseSummaryReal.forEach(r => {
                const semCurso = r.course_id === null
                const chave = semCurso ? 'null' : String(r.course_id)
                if (!mapa[chave]) {
                    mapa[chave] = {
                        id: semCurso ? 'null' : r.course_id,
                        nome: semCurso ? SEM_CURSO : (r.course_name || '').toUpperCase(),
                        curto: semCurso ? 'SEM CURSO' : null,
                        matriz: [[0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0]],
                    }
                }
                mapa[chave].matriz[regimeIdx(r.teacher_work_regime_id)][titulacaoIdx(r.teacher_titling_id)] += Number(r.total)
            })
            return Object.values(mapa)
        },

        cursosInfo() {
            const termo = this.cursoBusca.trim().toLowerCase()
            const selecionados = this.cursosAplicados.map(c => String(c.id))
            const regimeIdx = REGIMES.indexOf(this.regimeCat)
            const titulacaoIdx = TITULACOES.indexOf(this.tituloCat)
            const contagemCurso = c => this.contagemCurso(c, regimeIdx >= 0 ? regimeIdx : null, titulacaoIdx >= 0 ? titulacaoIdx : null)
            let lista = this.cursoStats.filter(c => (!selecionados.length || selecionados.includes(String(c.id))) && (!termo || c.nome.toLowerCase().includes(termo)))
            lista = lista.slice().sort((a, b) => {
                if (this.cursoOrdem === 'nome') return a.nome.localeCompare(b.nome, 'pt-BR')
                if (this.cursoOrdem === 'nomeDesc') return b.nome.localeCompare(a.nome, 'pt-BR')
                if (this.cursoOrdem === 'menor') return contagemCurso(a) - contagemCurso(b)
                return contagemCurso(b) - contagemCurso(a)
            })
            lista = lista.filter(c => c.nome === SEM_CURSO).concat(lista.filter(c => c.nome !== SEM_CURSO))
            const totalCursos = lista.length
            const porPagina = this.cursosTodos ? Math.max(1, totalCursos) : 8
            const paginas = Math.max(1, Math.ceil(totalCursos / porPagina))
            const pagina = Math.min(this.cursoPagina, paginas - 1)
            const inicio = pagina * porPagina
            const janela = lista.slice(inicio, inicio + porPagina)
            return {
                janela,
                texto: totalCursos
                    ? (this.cursosTodos ? 'Exibindo todos os ' + totalCursos + ' cursos' : 'Cursos ' + (inicio + 1) + '–' + Math.min(inicio + porPagina, totalCursos) + ' de ' + totalCursos + ' · página ' + (pagina + 1) + ' de ' + paginas)
                    : 'Nenhum curso encontrado',
                rotuloTodos: this.cursosTodos ? 'Exibir menos' : 'Ver todos (' + totalCursos + ')',
                paginas, pagina,
            }
        },
        janelaCursos() { return this.cursosInfo.janela },
        cursosTexto() { return this.cursosInfo.texto },
        cursosRotuloTodos() { return this.cursosInfo.rotuloTodos },

        ordemBotoes() {
            return [
                { value: 'maior', label: 'Mais docentes' },
                { value: 'menor', label: 'Menos docentes' },
                { value: 'nome', label: 'A–Z' },
                { value: 'nomeDesc', label: 'Z–A' },
            ].map(o => ({
                ...o,
                cor: this.cursoOrdem === o.value ? 'var(--blue-700)' : 'var(--text-muted)',
                fundo: this.cursoOrdem === o.value ? 'var(--info-soft)' : 'transparent',
            }))
        },

        ranking() {
            return this.janelaCursos.map(c => {
                const base = this.contagemCurso(c, null, null)
                const n = this.contagemCurso(c, null, 1) + this.contagemCurso(c, null, 2)
                const p = base ? (n / base) * 100 : 0
                return { curso: c.nome, ref: { id: c.id, name: c.nome }, p, texto: n + ' (' + p.toFixed(1) + '%)', largura: Math.round(p) + '%' }
            }).sort((a, b) => b.p - a.p)
        },

        // Barras "Professores por Curso e Regime/Titulação" — o filtro da outra dimensão
        // (titulação para o gráfico de regime e vice-versa) é aplicado na contagem.
        regimeChart() { return { grupos: this.gruposCursos('regime', REGIMES, this.regimeCat, 'setRegimeCat') } },
        titulacaoChart() { return { grupos: this.gruposCursos('titulacao', TITULACOES, this.tituloCat, 'setTituloCat') } },

        colunas() {
            return [
                ['curso', 'Cursos', 'left', '15%', 'Cursos'],
                ['nome', 'Professor', 'left', '18%', 'Professor'],
                ['titulacao', 'Titulação', 'left', '13%', 'Titulação'],
                ['regime', 'Regime', 'left', '12%', 'Regime de Trabalho'],
                ['vinculo', 'Vínculo', 'left', '9%', 'Tipo de Vínculo'],
                ['cargo', 'Cargo', 'left', '8%', 'Cargo'],
                ['chSala', 'CH Sala', 'right', '6%', 'CH semanal em sala de aula'],
                ['chExtra', 'CH Extra', 'right', '6%', 'CH semanal extraclasse'],
                ['ch', 'CH Total', 'right', '6%', 'CH semanal total'],
            ].map(([key, header, align, width, title]) => ({
                key, header, align, width, title,
                seta: this.sortKey === key ? (this.sortDir > 0 ? ' ↑' : ' ↓') : '',
            }))
        },

        // Tabela "Docentes Ativos" — dados reais, paginados no backend
        // (teacher_indicators/active-teachers). A linha segue o formato que o template já usa.
        tabela() {
            const meta = this.docentesMeta
            const fmt = v => Number(v || 0).toLocaleString('pt-BR', { maximumFractionDigits: 1 })
            const linhas = this.docentesReal.map(d => ({
                teacherId: d.teacher_id,
                curso: d.cursos.length ? d.cursos.join(', ') : '—',
                cursosLista: d.cursos,
                nome: d.nome,
                titulacao: d.titulacao || SEM_TITULACAO,
                regime: d.regime || SEM_REGIME,
                vinculo: d.vinculo || '—',
                cargo: d.cargo || '—',
                chSala: fmt(d.ch_sala),
                chExtra: fmt(d.ch_extra),
                ch: fmt(d.ch_total),
            }))
            const inicio = meta.total ? (meta.page - 1) * this.porPagina + 1 : 0
            return {
                linhas,
                semLinhas: !this.docentesCarregando && linhas.length === 0,
                totalTexto: meta.total.toLocaleString('pt-BR') + ' docentes ativos no recorte atual',
                paginaTexto: meta.total ? inicio + '–' + (inicio + linhas.length - 1) + ' de ' + meta.total.toLocaleString('pt-BR') : '0 registros',
                totalPaginas: Math.max(1, meta.last_page),
                pagina: meta.page - 1,
            }
        },
        linhas() { return this.tabela.linhas },
        semLinhas() { return this.tabela.semLinhas },
        totalTexto() { return this.tabela.totalTexto },
        paginaTexto() { return this.tabela.paginaTexto },

        porPaginaOpts() { return [8, 15, 25, 50, 100].map(n => ({ value: n, label: String(n) })) },

        // Botões numerados da paginação: primeira, última e uma janela de 2 páginas ao redor
        // da atual, com reticências nos saltos.
        paginasBotoes() {
            const total = this.tabela.totalPaginas
            const atual = this.page + 1
            const mostrar = new Set([1, total])
            for (let n = atual - 2; n <= atual + 2; n++) if (n >= 1 && n <= total) mostrar.add(n)
            const lista = []
            let anterior = 0
            Array.from(mostrar).sort((a, b) => a - b).forEach(n => {
                if (n - anterior > 1) lista.push({ reticencias: true })
                lista.push({ n, ativo: n === atual })
                anterior = n
            })
            return lista
        },

        // Há seleção nos campos de Empresa/Curso/Professor ainda não aplicada aos indicadores.
        filtrosPendentes() {
            const chave = list => list.map(i => String(i.id)).sort().join(',')
            return chave(this.empresasSelecionadas) !== chave(this.empresasAplicadas)
                || chave(this.cursosSelecionados) !== chave(this.cursosAplicados)
                || chave(this.professoresSelecionados) !== chave(this.professoresAplicados)
        },

        // Filtros de recorte enviados aos endpoints ("null" = sem curso / sem regime / sem
        // titulação). Cada indicador ignora o filtro da própria categoria, para mostrar todas
        // as categorias (só esmaecidas): regime ignora o de regime, titulação o de titulação.
        filtrosPartes() {
            const ids = list => list.map(i => i.id).filter(id => id != null)
            const regimeIds = { 'Horista': '1', 'Tempo Parcial': '2', 'Tempo Integral': '3', [SEM_REGIME]: 'null' }
            const titulacaoIds = { 'Especialização': '3', 'Mestrado': '4', 'Doutorado': '5,6', [SEM_TITULACAO]: '1,2,null' }
            const recorte = {}
            if (ids(this.cursosAplicados).length) recorte.course_ids = ids(this.cursosAplicados).join(',')
            if (ids(this.professoresAplicados).length) recorte.teacher_ids = ids(this.professoresAplicados).join(',')
            if (ids(this.empresasAplicadas).length) recorte.company_ids = ids(this.empresasAplicadas).join(',')
            return {
                recorte,
                regime: this.regimeCat ? { work_regime_ids: regimeIds[this.regimeCat] } : {},
                titulacao: this.tituloCat ? { titling_ids: titulacaoIds[this.tituloCat] } : {},
            }
        },
        filtrosBase() { return { ...this.baseCalculo, ...this.filtrosPartes.recorte, ...this.filtrosPartes.titulacao } },
        filtrosTitulacao() { return { ...this.baseCalculo, ...this.filtrosPartes.recorte, ...this.filtrosPartes.regime } },
        filtrosTodos() { return { ...this.filtrosBase, ...this.filtrosPartes.regime } },
        filtrosBaseKey() { return JSON.stringify(this.filtrosBase) },
        filtrosTitulacaoKey() { return JSON.stringify(this.filtrosTitulacao) },
        filtrosTodosKey() { return JSON.stringify(this.filtrosTodos) },

        // Parâmetros enviados ao backend para a tabela — qualquer mudança dispara nova consulta.
        docentesQuery() {
            const q = {
                ...this.filtrosTodos,
                page: this.page + 1,
                per_page: this.porPagina,
                sort_key: this.sortKey,
                sort_dir: this.sortDir > 0 ? 'asc' : 'desc',
            }
            if (this.busca.trim()) q.search = this.busca.trim()
            return q
        },
        docentesQueryKey() { return JSON.stringify(this.docentesQuery) },

        // CH Média Docente por Regime de Trabalho (dados reais): média = CH total / docentes
        // do regime, no recorte atual (o filtro de regime não se aplica ao próprio card).
        chRegimeMap() {
            const map = { 1: { n: 0, ch: 0 }, 2: { n: 0, ch: 0 }, 3: { n: 0, ch: 0 }, null: { n: 0, ch: 0 } }
            this.chRegimeReal.forEach(r => { map[r.teacher_work_regime_id === null ? 'null' : r.teacher_work_regime_id] = { n: Number(r.teachers), ch: Number(r.ch_total) } })
            return map
        },

        chipsCursos() {
            return this.cursosAplicados.map(item => ({ label: item.name, remove: () => this.removerCurso(item) }))
        },
        chipsEmpresas() {
            return this.empresasAplicadas.map(item => ({ label: item.name, remove: () => this.removerEmpresa(item) }))
        },
        chipsProfessores() {
            return this.professoresAplicados.map(item => ({ label: item.name, remove: () => this.removerProfessor(item) }))
        },
        chips() {
            const c = []
            if (this.regimeCat) c.push({ label: 'Regime: ' + this.regimeCat, remove: () => this.setRegimeCat(this.regimeCat) })
            if (this.tituloCat) c.push({ label: 'Titulação: ' + this.tituloCat, remove: () => this.setTituloCat(this.tituloCat) })
            if (this.busca.trim()) c.push({ label: 'Busca: ' + this.busca, remove: () => { this.busca = ''; this.page = 0 } })
            return c
        },

        // Mapa institution_type_id -> metas/observação, a partir das regras reais
        // cadastradas em institution_type_rules (mesma fonte da tela "Regras por Tipo
        // de Instituição"), para preencher o seletor "Perfil" dinamicamente.
        regrasPorTipoMap() {
            const map = {}
            this.institutionTypeRulesReal.forEach(r => {
                map[String(r.institution_type_id)] = {
                    metaTI: r.min_fulltime != null ? Number(r.min_fulltime) : 0,
                    metaStricto: r.min_master_doctors != null ? Number(r.min_master_doctors) : 0,
                    nota: r.description || 'Sem base legal/observação cadastrada para este tipo de instituição.',
                }
            })
            return map
        },
        perfilOpts() {
            return this.institutionTypesReal.map(t => ({ value: String(t.id), label: t.name }))
        },
        regimeRefOpts() {
            return [
                { value: 'auto', label: 'Automática pela CH atribuída' },
                { value: 'vinculo', label: 'Pelo vínculo cadastrado' },
            ]
        },
        cursoRefOpts() {
            return [
                { value: 'todos', label: 'Todos os cursos em que leciona' },
                { value: 'vinculo', label: 'Curso do vínculo contratual' },
                { value: 'maiorCh', label: 'Curso de maior CH no semestre' },
            ]
        },
        notaCh() {
            const r = this.rascunho
            const extra = Math.round(r.tiMin * r.tiExtra / 100)
            return 'A partir de ' + r.tiMin + ' h, no mínimo ' + r.tiExtra + '% (' + extra + ' h) em atividades extraclasse.'
        },
        notaRegimeRef() {
            return this.rascunho.regimeRef === 'vinculo'
                ? 'O regime vem do contrato principal ativo do docente, mesmo que a CH atribuída divirja.'
                : 'O regime é calculado automaticamente pela CH atribuída, conforme as regras de Regime de Trabalho.'
        },
        notaCursoRef() {
            const ref = this.rascunho.cursoRef
            if (ref === 'maiorCh') return 'O docente é contado só no curso em que tem a maior carga horária no período.'
            if (ref === 'vinculo') return 'O docente é contado nos cursos do seu contrato principal (poucos contratos têm curso cadastrado).'
            return 'O docente é contado em todos os cursos em que tem turma atribuída no período.'
        },
        perfilNota() {
            const regra = this.regrasPorTipoMap[this.rascunho.perfil]
            return regra ? regra.nota : 'Selecione um tipo de instituição para ver a base legal.'
        },

        // Aviso de escopo: este painel é um atalho direto para institution_type_rules
        // (a mesma regra da tela "Regras por Tipo de Instituição") — "Aplicar" grava
        // no banco e vale para todas as instituições daquele tipo, não só a atual.
        perfilAvisoGravacao() {
            const opt = this.perfilOpts.find(o => o.value === this.rascunho.perfil)
            const nome = opt ? opt.label : 'este tipo de instituição'
            return this.isInternal
                ? 'Ao aplicar, estas metas são gravadas na regra de "' + nome + '" e passam a valer para todas as instituições desse tipo.'
                : 'Você não tem permissão para gravar regras de tipo de instituição — fale com um usuário interno.'
        },

        carregandoIndicadores() { return this.pendentes > 0 },
        textoBotaoAplicar() { return this.salvandoParam ? 'Aplicando…' : 'Aplicar' },
    },

    methods: {
        ...mapActions('institutionTypeRule', ['ActionFindCurrentInstitutionTypeRule', 'ActionFindInstitutionTypeRules', 'ActionUpdateInstitutionTypeRule']),
        ...mapActions('institution', ['ActionFindInstitutionTypes']),
        ...mapActions('teacherWorkRegimeRule', ['ActionFindTeacherWorkRegimeRules', 'ActionCreateTeacherWorkRegimeRule', 'ActionUpdateTeacherWorkRegimeRule']),
        ...mapActions('domainTeacherIndicator', ['ActionSummaryByWorkRegime', 'ActionSummaryByTitling', 'ActionSummaryByTitlingDetail', 'ActionSummaryActiveTeachers', 'ActionActiveTeachersList', 'ActionSummaryByCourse', 'ActionSummaryChByRegime']),

        carregarInstitutionTypeRuleAtual() {
            this.ActionFindCurrentInstitutionTypeRule()
                .then(res => { this.institutionTypeRuleAtual = res.data })
                .catch(() => { this.institutionTypeRuleAtual = null })
        },

        carregarInstitutionTypesReal() {
            this.ActionFindInstitutionTypes()
                .then(res => { this.institutionTypesReal = res.data || [] })
                .catch(() => { this.institutionTypesReal = [] })
        },

        carregarInstitutionTypeRulesReal() {
            this.ActionFindInstitutionTypeRules({ with: 'institutionType' })
                .then(res => { this.institutionTypeRulesReal = res.data || [] })
                .catch(() => { this.institutionTypeRulesReal = [] })
        },

        carregarTeacherWorkRegimeRulesReal() {
            this.ActionFindTeacherWorkRegimeRules({ with: 'teacherWorkRegime' })
                .then(res => { this.teacherWorkRegimeRulesReal = res.data || [] })
                .catch(() => { this.teacherWorkRegimeRulesReal = [] })
        },

        carregarRegimeSummaryReal() {
            this.rastrear(this.ActionSummaryByWorkRegime(this.filtrosBase))
                .then(res => { this.regimeSummaryReal = res.data || [] })
                .catch(() => { this.regimeSummaryReal = [] })
            this.rastrear(this.ActionSummaryByWorkRegime({ ...this.filtrosBase, previous: 1 }))
                .then(res => { this.regimeSummaryAnterior = res.data || [] })
                .catch(() => { this.regimeSummaryAnterior = [] })
        },

        carregarActiveTeachersSummaryReal() {
            this.rastrear(this.ActionSummaryActiveTeachers(this.filtrosTodos))
                .then(res => { this.activeTeachersSummaryReal = res.data || { total: 0 } })
                .catch(() => { this.activeTeachersSummaryReal = { total: 0 } })
            this.rastrear(this.ActionSummaryActiveTeachers({ ...this.filtrosTodos, previous: 1 }))
                .then(res => { this.activeTeachersAnterior = res.data || { total: 0 } })
                .catch(() => { this.activeTeachersAnterior = { total: 0 } })
        },

        carregarChRegime() {
            const req = this._chRegimeReq = (this._chRegimeReq || 0) + 1
            this.rastrear(this.ActionSummaryChByRegime(this.filtrosBase))
                .then(res => { if (req === this._chRegimeReq) this.chRegimeReal = res.data || [] })
                .catch(() => { if (req === this._chRegimeReq) this.chRegimeReal = [] })
            this.rastrear(this.ActionSummaryChByRegime({ ...this.filtrosBase, previous: 1 }))
                .then(res => { if (req === this._chRegimeReq) this.chRegimeAnterior = res.data || [] })
                .catch(() => { if (req === this._chRegimeReq) this.chRegimeAnterior = [] })
        },

        carregarCourseSummary() {
            const req = this._courseSummaryReq = (this._courseSummaryReq || 0) + 1
            const { teacher_ids, company_ids } = this.filtrosPartes.recorte
            this.rastrear(this.ActionSummaryByCourse({ ...this.baseCalculo, ...(teacher_ids ? { teacher_ids } : {}), ...(company_ids ? { company_ids } : {}) }))
                .then(res => { if (req === this._courseSummaryReq) this.courseSummaryReal = res.data || [] })
                .catch(() => { if (req === this._courseSummaryReq) this.courseSummaryReal = [] })
        },

        // Conta a requisição como pendente até terminar (com sucesso ou erro).
        rastrear(promessa) {
            this.pendentes++
            const fim = () => { this.pendentes = Math.max(0, this.pendentes - 1) }
            promessa.then(fim, fim)
            return promessa
        },

        // Busca digitada dispara várias mudanças seguidas — agrupa numa única consulta.
        agendarDocentes() {
            clearTimeout(this._docentesTimer)
            this._docentesTimer = setTimeout(() => this.carregarDocentes(), 250)
        },

        carregarDocentes() {
            const req = this._docentesReq = (this._docentesReq || 0) + 1
            this.docentesCarregando = true
            this.rastrear(this.ActionActiveTeachersList(this.docentesQuery))
                .then(res => {
                    if (req !== this._docentesReq) return
                    this.docentesReal = res.data || []
                    this.docentesMeta = { page: res.meta.page, total: res.meta.total, last_page: res.meta.last_page }
                })
                .catch(() => {
                    if (req !== this._docentesReq) return
                    this.docentesReal = []
                    this.docentesMeta = { page: 1, total: 0, last_page: 1 }
                })
                .finally(() => { if (req === this._docentesReq) this.docentesCarregando = false })
        },

        carregarTitlingDetailReal() {
            this.rastrear(this.ActionSummaryByTitlingDetail(this.filtrosTitulacao))
                .then(res => { this.titlingDetailReal = res.data || [] })
                .catch(() => { this.titlingDetailReal = [] })
            this.rastrear(this.ActionSummaryByTitlingDetail({ ...this.filtrosTitulacao, previous: 1 }))
                .then(res => { this.titlingDetailAnterior = res.data || [] })
                .catch(() => { this.titlingDetailAnterior = [] })
        },

        carregarTitlingSummaryReal() {
            this.rastrear(this.ActionSummaryByTitling(this.filtrosTitulacao))
                .then(res => { this.titlingSummaryReal = res.data || { total: 0, mestres_doutores: 0 } })
                .catch(() => { this.titlingSummaryReal = { total: 0, mestres_doutores: 0 } })
        },

        // Complemento do tooltip dos cards: "· +12 vs. período anterior" (vazio sem comparação).
        textoVariacao(v) {
            return v === null ? '' : ' · ' + (v >= 0 ? '+' : '−') + Math.abs(v).toLocaleString('pt-BR') + ' vs. período anterior'
        },

        pct(n, d) { return d ? (n / d * 100).toFixed(1) + '%' : '—' },

        metaChip(atual, meta) {
            if (!meta || meta <= 0) return null
            const ok = atual >= meta
            const texto = meta.toFixed(1).replace('.', ',') + '%'
            return { ok, texto, tooltip: (ok ? 'Meta atingida' : 'Abaixo da meta') + ' · mínimo de ' + texto + ' definido nas parametrizações' }
        },

        confSimples(atual, meta) {
            if (!meta || meta <= 0) return { valor: atual.toFixed(1).replace('.', ',') + '%', status: 'Sem meta', cor: 'var(--text-muted)', fundo: 'var(--gray-150)' }
            const ok = atual >= meta
            return {
                valor: atual.toFixed(1).replace('.', ',') + '%',
                status: ok ? 'Regular' : 'Irregular',
                cor: ok ? 'var(--success)' : 'var(--danger)',
                fundo: ok ? 'var(--success-soft)' : 'var(--danger-soft)',
            }
        },

        fatia(cx, cy, r, a0, a1) {
            const px = a => [cx + r * Math.cos(a), cy + r * Math.sin(a)]
            const [x0, y0] = px(a0)
            const [x1, y1] = px(a1)
            const grande = (a1 - a0) > Math.PI ? 1 : 0
            return 'M' + cx + ',' + cy + ' L' + x0.toFixed(2) + ',' + y0.toFixed(2) + ' A' + r + ',' + r + ' 0 ' + grande + ' 1 ' + x1.toFixed(2) + ',' + y1.toFixed(2) + ' Z'
        },

        // Soma de uma célula da matriz [regime][titulação] do curso; null = todas as categorias.
        contagemCurso(curso, regimeIdx, titulacaoIdx) {
            let soma = 0
            curso.matriz.forEach((linha, r) => linha.forEach((n, t) => {
                if ((regimeIdx === null || regimeIdx === r) && (titulacaoIdx === null || titulacaoIdx === t)) soma += n
            }))
            return soma
        },

        gruposCursos(campo, cats, catAtual, setCatName) {
            const janela = this.janelaCursos
            const outroRegime = campo === 'regime' ? -1 : REGIMES.indexOf(this.regimeCat)
            const outraTitulacao = campo === 'titulacao' ? -1 : TITULACOES.indexOf(this.tituloCat)
            const matriz = janela.map(c => cats.map((cat, i) => this.contagemCurso(
                c,
                campo === 'regime' ? i : (outroRegime >= 0 ? outroRegime : null),
                campo === 'titulacao' ? i : (outraTitulacao >= 0 ? outraTitulacao : null),
            )))
            const maxBarra = Math.max(1, ...matriz.map(r => Math.max(...r)))
            return janela.map((c, gi) => ({
                curso: c.nome,
                rotulo: c.curto || c.nome,
                barras: cats.map((cat, i) => ({
                    valor: matriz[gi][i] || '',
                    altura: Math.round((matriz[gi][i] / maxBarra) * 150) + 'px',
                    cor: SERIE[i],
                    opacidade: catAtual && catAtual !== cat ? 0.25 : 1,
                    title: c.nome + ' · ' + cat + ': ' + matriz[gi][i] + ' professores',
                    onClick: () => { this.setCurso({ id: c.id, name: c.nome }); this[setCatName](cat) },
                })),
            }))
        },

        setRegimeCat(v) { this.regimeCat = this.regimeCat === v ? '' : v; this.page = 0 },
        setTituloCat(v) { this.tituloCat = this.tituloCat === v ? '' : v; this.page = 0 },

        // Passa a seleção dos campos (Empresa, Curso, Professor) para os indicadores.
        aplicarFiltros() {
            this.empresasAplicadas = [...this.empresasSelecionadas]
            this.cursosAplicados = [...this.cursosSelecionados]
            this.professoresAplicados = [...this.professoresSelecionados]
            this.page = 0
        },

        // Alterna um curso ({ id, name }) — usado pelos cliques nos gráficos/ranking, que
        // aplicam na hora (campo e indicadores juntos). id 'null' = docentes sem curso no período.
        setCurso(c) {
            const idx = this.cursosAplicados.findIndex(x => String(x.id) === String(c.id))
            const lista = idx >= 0
                ? this.cursosAplicados.filter((x, i) => i !== idx)
                : [...this.cursosAplicados, { id: c.id, name: c.name }]
            this.cursosAplicados = lista
            this.cursosSelecionados = [...lista]
            this.page = 0
        },
        // Remover um chip aplica na hora e tira o item também do campo.
        removerCurso(item) {
            this.cursosAplicados = this.cursosAplicados.filter(c => String(c.id) !== String(item.id))
            this.cursosSelecionados = this.cursosSelecionados.filter(c => String(c.id) !== String(item.id))
            this.page = 0
        },
        removerEmpresa(item) {
            this.empresasAplicadas = this.empresasAplicadas.filter(e => String(e.id) !== String(item.id))
            this.empresasSelecionadas = this.empresasSelecionadas.filter(e => String(e.id) !== String(item.id))
            this.page = 0
        },
        removerProfessor(item) {
            this.professoresAplicados = this.professoresAplicados.filter(p => String(p.id) !== String(item.id))
            this.professoresSelecionados = this.professoresSelecionados.filter(p => String(p.id) !== String(item.id))
            this.page = 0
        },

        limparFiltros() {
            this.cursosSelecionados = []; this.professoresSelecionados = []; this.empresasSelecionadas = []
            this.cursosAplicados = []; this.professoresAplicados = []; this.empresasAplicadas = []
            this.regimeCat = ''; this.tituloCat = ''; this.busca = ''; this.page = 0
        },

        setBusca(e) { this.busca = e.target.value; this.page = 0 },
        setCursoBusca(e) { this.cursoBusca = e.target.value; this.cursoPagina = 0 },
        setCursoOrdem(v) { this.cursoOrdem = v; this.cursoPagina = 0 },
        alternarCursosTodos() { this.cursosTodos = !this.cursosTodos; this.cursoPagina = 0 },
        cursoPaginaAnterior() { this.cursoPagina = Math.max(0, this.cursosInfo.pagina - 1) },
        cursoPaginaProxima() { this.cursoPagina = Math.min(this.cursosInfo.paginas - 1, this.cursosInfo.pagina + 1) },

        sortBy(key) { this.sortDir = this.sortKey === key ? -this.sortDir : 1; this.sortKey = key },
        irParaPagina(i) { this.page = Math.min(Math.max(0, i), this.tabela.totalPaginas - 1) },
        setPorPagina(e) { this.porPagina = Number(e.target.value); this.page = 0 },
        paginaAnterior() { this.page = Math.max(0, this.page - 1) },
        paginaProxima() { this.page = Math.min(this.tabela.totalPaginas - 1, this.page + 1) },

        abrirParam() {
            this.paramAberto = true
            this.rascunhoState = { ...this.params }
            this.paramMensagem = ''
            this.paramErro = false
        },
        fecharParam() { this.paramAberto = false; this.rascunhoState = null },

        // Aplica sempre grava direto no banco — este painel é um atalho para as
        // mesmas regras das telas "Regras por Tipo de Instituição" (metas mínimas,
        // restrita a usuários internos, vale para todas as instituições daquele
        // tipo) e "Regras de Regime de Trabalho" (CH por regime, sem restrição de
        // permissão, escopada só à instituição atual).
        aplicarParam() {
            const rascunho = { ...this.rascunho }

            let regraAtual = null
            if (this.isInternal) {
                regraAtual = this.institutionTypeRulesReal.find(r => String(r.institution_type_id) === rascunho.perfil)
                if (!regraAtual) {
                    this.paramErro = true
                    this.paramMensagem = 'Não foi possível localizar a regra deste tipo de instituição.'
                    return
                }
            }

            this.salvandoParam = true
            this.paramMensagem = ''
            this.paramErro = false

            const tarefas = [
                this.salvarRegraCh(1, rascunho.hrMin, rascunho.hrExtra),
                this.salvarRegraCh(2, rascunho.tpMin, rascunho.tpExtra),
                this.salvarRegraCh(3, rascunho.tiMin, rascunho.tiExtra),
            ]
            if (regraAtual) {
                tarefas.push(this.ActionUpdateInstitutionTypeRule({
                    id: regraAtual.id,
                    institution_type_id: regraAtual.institution_type_id,
                    min_fulltime: rascunho.metaTI,
                    min_master_doctors: rascunho.metaStricto,
                    description: regraAtual.description,
                }))
            }

            Promise.all(tarefas)
                .then(() => {
                    this.paramsState = rascunho
                    this.paramAberto = false
                    this.rascunhoState = null
                    this.page = 0
                    this.carregarTeacherWorkRegimeRulesReal()
                    if (regraAtual) {
                        this.carregarInstitutionTypeRulesReal()
                        if (this.institutionTypeRuleAtual && String(this.institutionTypeRuleAtual.institution_type_id) === rascunho.perfil) {
                            this.carregarInstitutionTypeRuleAtual()
                        }
                    }
                })
                .catch(error => {
                    this.paramErro = true
                    this.paramMensagem = (error && error.message) || 'Não foi possível gravar as parametrizações.'
                })
                .finally(() => { this.salvandoParam = false })
        },

        // Grava CH mínima/% extraclasse de um regime em teacher_work_regime_rules —
        // cria a regra se a instituição ainda não tiver uma para esse regime.
        salvarRegraCh(teacherWorkRegimeId, workLoadMin, percentActivities) {
            const regra = this.teacherWorkRegimeRulesReal.find(r => r.teacher_work_regime_id === teacherWorkRegimeId)
            const payload = {
                institution_id: this.acesso && this.acesso.instituicao ? this.acesso.instituicao.id : null,
                teacher_work_regime_id: teacherWorkRegimeId,
                work_load_min: workLoadMin,
                percent_activities: percentActivities,
            }
            return regra
                ? this.ActionUpdateTeacherWorkRegimeRule({ id: regra.id, ...payload })
                : this.ActionCreateTeacherWorkRegimeRule(payload)
        },
        // "Restaurar referência MEC" — volta às metas realmente cadastradas em
        // institution_type_rules para o tipo da própria instituição logada.
        restaurarParam() {
            this.rascunhoState = { ...PARAM_PADRAO, ...this.metasPadraoInstituicao, ...this.chPadraoInstituicao, perfil: this.perfilPadrao }
            this.paramMensagem = ''
            this.paramErro = false
        },

        num1(v) { const n = Number(String(v).replace(',', '.')); return isNaN(n) ? 0 : n },
        setPerfil(e) {
            const v = e.target.value
            const regra = this.regrasPorTipoMap[v]
            this.rascunhoState = {
                ...this.rascunho,
                perfil: v,
                metaTI: regra ? regra.metaTI : 0,
                metaStricto: regra ? regra.metaStricto : 0,
            }
        },
        setMetaTI(e) { this.rascunhoState = { ...this.rascunho, metaTI: this.num1(e.target.value) } },
        setMetaStricto(e) { this.rascunhoState = { ...this.rascunho, metaStricto: this.num1(e.target.value) } },
        setHrMin(e) { this.rascunhoState = { ...this.rascunho, hrMin: this.num1(e.target.value) } },
        setHrExtra(e) { this.rascunhoState = { ...this.rascunho, hrExtra: this.num1(e.target.value) } },
        setTpMin(e) { this.rascunhoState = { ...this.rascunho, tpMin: this.num1(e.target.value) } },
        setTpExtra(e) { this.rascunhoState = { ...this.rascunho, tpExtra: this.num1(e.target.value) } },
        setTiMin(e) { this.rascunhoState = { ...this.rascunho, tiMin: this.num1(e.target.value) } },
        setTiExtra(e) { this.rascunhoState = { ...this.rascunho, tiExtra: this.num1(e.target.value) } },
        setLicenciados(e) { this.rascunhoState = { ...this.rascunho, licenciados: e.target.checked } },
        setCursoRef(e) { this.rascunhoState = { ...this.rascunho, cursoRef: e.target.value } },
        setRegimeRef(e) { this.rascunhoState = { ...this.rascunho, regimeRef: e.target.value } },

        // Baixa em CSV a tabela "Docentes Ativos" inteira (todas as páginas do recorte atual, com os
        // mesmos filtros, busca e ordenação da tela), buscando o backend de 200 em 200.
        async baixarDocentesCSV() {
            if (this.baixandoCsv) return
            this.baixandoCsv = true
            try {
                const txt = v => {
                    const t = v === null || v === undefined ? '' : String(v)
                    return /[;"\n]/.test(t) ? '"' + t.replace(/"/g, '""') + '"' : t
                }
                const num = v => String(v ?? 0).replace('.', ',')
                const linhas = [['Cursos', 'Professor', 'Titulação', 'Regime de Trabalho', 'Vínculo', 'Cargo', 'CH Sala', 'CH Extra', 'CH Total']]
                let pagina = 1
                let ultima = 1
                while (pagina <= ultima) {
                    const res = await this.ActionActiveTeachersList({ ...this.docentesQuery, page: pagina, per_page: 200 })
                    res.data.forEach(d => linhas.push([
                        d.cursos.join(' / '), d.nome, d.titulacao || SEM_TITULACAO, d.regime || SEM_REGIME,
                        d.vinculo || '', d.cargo || '', num(d.ch_sala), num(d.ch_extra), num(d.ch_total),
                    ]))
                    ultima = res.meta.last_page
                    pagina++
                }
                const csv = linhas.map(l => l.map(txt).join(';')).join('\n')
                const url = URL.createObjectURL(new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' }))
                const a = document.createElement('a')
                a.href = url
                a.download = 'docentes-ativos.csv'
                a.click()
                setTimeout(() => URL.revokeObjectURL(url), 2000)
            } finally {
                this.baixandoCsv = false
            }
        },
    },
}
